import { TextField, useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { IconEdit } from '@calendly/ui/components/glyphs/IconEdit'
import { UiIcon } from '@calendly/ui/components/ui-icon'

import { ConfigurableItemCard } from 'features/event_type_editor_crud/components/configurable_item_card'

export const CustomLocationCard = ({
  fieldNamePrefix,
  subtitle,
  onDelete,
  onCancel,
  onDone,
}) => {
  const [{ value: locationValue }] = useFormField({ name: `${fieldNamePrefix}.location` })

  return (
    <ConfigurableItemCard
      icon={<UiIcon icon={IconEdit} size="medium" title="" />}
      title={I18n.t('publisher.event_type_editor_crud.meeting_details.location.custom_card_title')}
      subtitle={subtitle}
      deleteLabel={I18n.t('publisher.action.remove')}
      onDelete={onDelete}
      onCancel={onCancel}
      onDone={onDone}
      isDoneDisabled={!locationValue?.trim()}
    >
      <TextField
        name={`${fieldNamePrefix}.location`}
        label={I18n.t('publisher.event_type_editor_crud.meeting_details.location.custom_location_field_label')}
        placeholder={I18n.t('publisher.event_type_editor_crud.meeting_details.location.custom_location_field_placeholder')}
        size="medium"
        required
        requiredMark="asterisk"
        maxLength={255}
        errorOnInputOnly
      />
    </ConfigurableItemCard>
  )
}
